function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M117.504 34.1021H136.364C137.402 34.1021 138.944 34.1809 138.944 34.1809C142.853 34.3836 146.911 34.3359 147.741 36.6207H147.932V35.5724C147.932 32.5547 143.9 31.1018 139.135 31.1018C139.135 31.1018 135.329 31 136.364 31H117.504H99.568C100.604 31 96.7971 31.1018 96.7971 31.1018C91.7514 31.2596 88 34.2892 88 37.2169V39.8191L88.1917 39.842C88.743 35.3146 93.0796 34.3836 96.9879 34.1809C96.9879 34.1809 98.5325 34.1021 99.568 34.1021H117.504Z",
  fill: "#9FA0A0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M117.504 40.3842H136.364C137.402 40.3842 138.944 40.4631 138.944 40.4631C142.853 40.6658 146.911 40.6181 147.741 42.9038H147.932V41.8545C147.932 38.8369 143.9 37.3821 139.135 37.3821C139.135 37.3821 135.329 37.2812 136.364 37.2812H117.504H99.568C100.604 37.2812 96.7971 37.3821 96.7971 37.3821C91.7514 37.5427 88 40.5713 88 43.4991V46.1013L88.1917 46.1242C88.743 41.5968 93.0796 40.6658 96.9879 40.4631C96.9879 40.4631 98.5325 40.3842 99.568 40.3842H117.504Z",
  fill: "#9FA0A0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M188.485 34.1021H169.625C168.586 34.1021 167.045 34.1809 167.045 34.1809C163.136 34.3836 159.077 34.3359 158.247 36.6207H158.057V35.5724C158.057 32.5547 162.09 31.1018 166.854 31.1018C166.854 31.1018 170.66 31 169.625 31H188.485H206.422C205.384 31 209.192 31.1018 209.192 31.1018C214.238 31.2596 217.99 34.2882 217.99 37.2169V39.8191L217.798 39.842C217.246 35.3146 212.909 34.3836 209.001 34.1809C209.001 34.1809 207.458 34.1021 206.422 34.1021H188.485Z",
  fill: "#9FA0A0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M188.485 40.3842H169.625C168.586 40.3842 167.045 40.4631 167.045 40.4631C163.136 40.6658 159.077 40.6181 158.247 42.9038H158.057V41.8545C158.057 38.8369 162.09 37.3821 166.854 37.3821C166.854 37.3821 170.66 37.2812 169.625 37.2812H188.485H206.422C205.384 37.2812 209.192 37.3821 209.192 37.3821C214.238 37.5417 217.99 40.5704 217.99 43.4982V46.1004L217.798 46.1233C217.246 41.5959 212.909 40.6649 209.001 40.4622C209.001 40.4622 207.458 40.3833 206.422 40.3833H188.485V40.3842Z",
  fill: "#9FA0A0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5681 46.7168H117.504L117.499 43.6147H99.5681C100.605 43.6147 96.7972 43.7156 96.7972 43.7156C91.7506 43.8752 88.001 46.9057 88.001 49.8317V52.4339L88.1918 52.4568C88.743 47.9303 93.0796 46.9984 96.9879 46.7957C96.9879 46.7957 98.5325 46.7168 99.5681 46.7168Z",
  fill: "#9FA0A0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5681 52.9346H117.504L117.499 49.8325H99.5681C100.605 49.8325 96.7972 49.9334 96.7972 49.9334C91.7506 50.0912 88.001 53.1217 88.001 56.0495V58.6516L88.1918 58.6736C88.743 54.1471 93.0796 53.2152 96.9879 53.0125C96.9879 53.0125 98.5325 52.9346 99.5681 52.9346Z",
  fill: "#9FA0A0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5681 59.2413H117.504L117.499 56.1401H99.5681C100.605 56.1401 96.7972 56.2419 96.7972 56.2419C91.7506 56.3988 88.001 59.4293 88.001 62.3571V64.9592L88.1918 64.9813C88.743 60.4538 93.0796 59.5229 96.9879 59.3202C96.9879 59.3202 98.5325 59.2413 99.5681 59.2413Z",
  fill: "#9FA0A0"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5681 65.5488H117.504L117.499 62.4468H99.5681C100.605 62.4468 96.7972 62.5486 96.7972 62.5486C91.7506 62.7064 88.001 65.735 88.001 68.6637V71.2668L88.1918 71.2888C88.743 66.7614 93.0796 65.8304 96.9879 65.6277C96.9879 65.6277 98.5325 65.5488 99.5681 65.5488Z",
  fill: "#9FA0A0"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M99.5681 71.811H117.504L117.499 68.709H99.5681C100.605 68.709 96.7972 68.8108 96.7972 68.8108C91.7506 68.9695 88.001 71.9991 88.001 74.9268V77.5272L88.1918 77.5501C88.743 73.0227 93.0796 72.0917 96.9879 71.889C96.9879 71.8899 98.5325 71.811 99.5681 71.811Z",
  fill: "#9FA0A0"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M206.434 46.7168H188.498L188.503 43.6147H206.434C205.396 43.6147 209.205 43.7156 209.205 43.7156C214.25 43.8752 218.001 46.9057 218.001 49.8317V52.4339L217.81 52.4568C217.258 47.9303 212.922 46.9984 209.014 46.7957C209.013 46.7957 207.469 46.7168 206.434 46.7168Z",
  fill: "#9FA0A0"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M206.434 52.9346H188.498L188.503 49.8325H206.434C205.396 49.8325 209.205 49.9334 209.205 49.9334C214.25 50.0912 218.001 53.1217 218.001 56.0495V58.6516L217.81 58.6736C217.258 54.1471 212.922 53.2152 209.014 53.0125C209.013 53.0125 207.469 52.9346 206.434 52.9346Z",
  fill: "#9FA0A0"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M206.434 59.2413H188.498L188.503 56.1401H206.434C205.396 56.1401 209.205 56.2419 209.205 56.2419C214.25 56.3988 218.001 59.4293 218.001 62.3571V64.9592L217.81 64.9813C217.258 60.4538 212.922 59.5229 209.014 59.3202C209.013 59.3202 207.469 59.2413 206.434 59.2413Z",
  fill: "#9FA0A0"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M206.434 65.5488H188.498L188.503 62.4468H206.434C205.396 62.4468 209.205 62.5486 209.205 62.5486C214.25 62.7064 218.001 65.735 218.001 68.6637V71.2668L217.81 71.2888C217.258 66.7614 212.922 65.8304 209.014 65.6277C209.013 65.6277 207.469 65.5488 206.434 65.5488Z",
  fill: "#9FA0A0"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M206.434 71.811H188.498L188.503 68.709H206.434C205.396 68.709 209.205 68.8108 209.205 68.8108C214.25 68.9695 218.001 71.9991 218.001 74.9268V77.5272L217.81 77.5501C217.258 73.0227 212.922 72.0917 209.014 71.889C209.013 71.8899 207.469 71.811 206.434 71.811Z",
  fill: "#9FA0A0"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M152.979 46.7296C153.936 46.7296 156.448 46.7066 157.483 46.7066C158.521 46.7066 159.788 46.7222 161.291 46.8194C163.125 46.9368 168.769 46.5113 170.367 50.4067L170.559 50.3856L170.548 47.9018C169.924 44.5576 163.45 43.9036 161.762 43.8247C160.914 43.7853 159.142 43.6513 157.55 43.6513C156.625 43.6513 152.978 43.6284 152.978 43.6284C152.978 43.6284 149.407 43.6513 148.405 43.6513C146.813 43.6513 145.04 43.7862 144.192 43.8247C142.504 43.9036 136.03 44.5576 135.407 47.9018L135.396 50.3856L135.587 50.4067C137.186 46.5113 142.83 46.9368 144.665 46.8194C146.166 46.7231 147.436 46.7066 148.471 46.7066C149.509 46.7066 152.021 46.7296 152.979 46.7296Z",
  fill: "#9FA0A0"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M152.979 52.9839C153.936 52.9839 156.448 52.961 157.483 52.961C158.521 52.961 159.788 52.9784 161.291 53.0756C163.125 53.193 168.769 52.7656 170.367 56.661L170.559 56.639L170.548 54.157C169.924 50.8119 163.45 50.1588 161.762 50.08C160.914 50.0414 159.142 49.9048 157.55 49.9048C156.625 49.9048 152.978 49.8818 152.978 49.8818C152.978 49.8818 149.407 49.9048 148.405 49.9048C146.813 49.9048 145.04 50.0414 144.192 50.08C142.504 50.1588 136.03 50.8119 135.407 54.157L135.396 56.639L135.587 56.661C137.186 52.7656 142.83 53.193 144.665 53.0756C146.166 52.9784 147.436 52.961 148.471 52.961C149.509 52.961 152.021 52.9839 152.979 52.9839Z",
  fill: "#9FA0A0"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M152.979 59.3101C153.936 59.3101 156.448 59.2871 157.483 59.2871C158.521 59.2871 159.788 59.3046 161.291 59.3999C163.125 59.5183 168.769 59.0908 170.367 62.9872L170.559 62.9652L170.548 60.4832C169.924 57.1381 163.45 56.485 161.762 56.4061C160.914 56.3667 159.142 56.2309 157.55 56.2309C156.625 56.2309 152.978 56.208 152.978 56.208C152.978 56.208 149.407 56.2309 148.405 56.2309C146.813 56.2309 145.04 56.3658 144.192 56.4061C142.504 56.485 136.03 57.1381 135.407 60.4832L135.396 62.9652L135.587 62.9872C137.186 59.0918 142.83 59.5192 144.665 59.3999C146.166 59.3036 147.436 59.2871 148.471 59.2871C149.509 59.2871 152.021 59.3101 152.979 59.3101Z",
  fill: "#9FA0A0"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M152.979 65.5986C153.936 65.5986 156.448 65.5757 157.483 65.5757C158.521 65.5757 159.788 65.5931 161.291 65.6885C163.125 65.8059 168.769 65.3803 170.367 69.2758L170.559 69.2538L170.549 66.7718C169.925 63.4266 163.451 62.7717 161.763 62.6947C160.915 62.6543 159.143 62.5195 157.551 62.5195C156.626 62.5195 152.979 62.4966 152.979 62.4966C152.979 62.4966 149.408 62.5195 148.405 62.5195C146.814 62.5195 145.041 62.6543 144.193 62.6947C142.505 62.7727 136.031 63.4266 135.408 66.7718L135.396 69.2538L135.588 69.2758C137.187 65.3803 142.831 65.8059 144.666 65.6885C146.167 65.5931 147.437 65.5757 148.472 65.5757C149.509 65.5757 152.021 65.5986 152.979 65.5986Z",
  fill: "#9FA0A0"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M152.979 71.8662C153.936 71.8662 156.448 71.8432 157.483 71.8432C158.521 71.8432 159.788 71.8588 161.291 71.956C163.125 72.0734 168.769 71.6469 170.367 75.5424L170.559 75.5195L170.548 73.0374C169.924 69.6932 163.45 69.0393 161.762 68.9604C160.914 68.9219 159.142 68.7852 157.55 68.7852C156.625 68.7852 152.978 68.7632 152.978 68.7632C152.978 68.7632 149.407 68.7852 148.405 68.7852C146.813 68.7852 145.04 68.9219 144.192 68.9604C142.504 69.0393 136.03 69.6932 135.407 73.0374L135.396 75.5195L135.587 75.5424C137.186 71.6469 142.83 72.0725 144.665 71.956C146.166 71.8588 147.436 71.8432 148.471 71.8432C149.509 71.8432 152.021 71.8662 152.979 71.8662Z",
  fill: "#9FA0A0"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M100.456 95.0435L100.851 95.3563L97.9408 104.394L94.4609 93.9805H88.4448V94.9371L88.8567 95.3802V108.316H92.0082V96.5386H92.1348L96.1724 108.316H99.3607L103.419 96.5386H103.543V108.316H106.891V93.9805H100.456V95.0435Z",
  fill: "black"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M138.368 93.6025C135.92 93.6025 134.192 94.2363 132.927 95.5957C131.693 96.9275 131.037 98.8647 131.037 101.203C131.037 105.93 133.637 108.64 138.168 108.64C142.689 108.64 145.391 105.819 145.391 101.094C145.392 96.4037 142.766 93.6025 138.368 93.6025ZM138.241 96.2524C141.279 96.2524 141.917 98.8766 141.917 101.078C141.917 104.361 140.68 105.957 138.135 105.957C135.742 105.957 134.528 104.327 134.528 101.113C134.528 98.8958 135.174 96.2524 138.241 96.2524Z",
  fill: "black"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M182.43 102.854L181.364 102.153L181.028 101.21C183.051 100.624 183.995 99.5164 183.995 97.7361C183.995 96.2364 183.156 95.0725 181.63 94.4634C180.694 94.0883 179.926 93.981 178.209 93.981H170.899V94.9376L171.313 95.3816V108.316H174.75V102.446H179.093L181.069 108.316H184.53L182.904 103.463C182.819 103.223 182.649 103.006 182.43 102.854ZM174.75 96.5382H177.815C180.278 96.5382 180.611 97.4068 180.611 98.258C180.611 99.2899 180.098 99.9759 177.599 99.9759H174.75V96.5382Z",
  fill: "black"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M216.592 106.912V93.9805H212.723V94.9371L213.138 95.3811V106.917L212.723 107.253V108.315H217.022V107.253L216.592 106.912Z",
  fill: "black"
});

var _ref26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoMori(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMori);
export default __webpack_public_path__ + "static/media/logo_mori.e20a267a.svg";
export { ForwardRef as ReactComponent };